module.exports = __webpack_public_path__ + "static/media/tom-ford.404803b0.jpg";